import { createMedia } from '@artsy/fresnel';

export const { MediaContextProvider, Media } = createMedia({
    breakpoints: {
        sm: 0,
        mobile: 779,
        computer: 780,
    },
});
